module.exports = __webpack_public_path__ + "static/img/1088.2d2f0f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1088.jpg
// module id = 270
// module chunks = 0